import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { Location } from '@angular/common';
import { BootstrapMarketoService } from 'lib/services/bootstrap/bootstrap-marketo.service';
import { ButtonComponent } from '../../../../../components/button/button.component';

@Component({
    selector: 'cms-partial-category-top-lead-gen',
    templateUrl: './lead-gen.component.html',
    styleUrls: ['./lead-gen.component.scss'],
    standalone: true,
    imports: [CommonModule, ButtonComponent],
})
export class LeadGenComponent extends CmsPartialComponentClass {
    @Input() leadGenRow: any;
    @Input() dataUrl: string;
    @Input() dataTitle: string;
    @Input() solutionID: string;
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        breakpointObserver: BreakpointObserver,
        public bootstrapMarketoService: BootstrapMarketoService,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                bootstrapMarketoService,
                breakpointObserver,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
